import { css } from '@emotion/css';

import { covertColorToRGBA } from '@lyearn/style';

export const dismissPillBackgroundStyles = (colorCode: string, appearance: string) => css`
  &:hover {
    background-color: ${covertColorToRGBA(colorCode, appearance === 'inverse' ? 50 : 5)};
  }
  &:focus {
    background-color: ${covertColorToRGBA(colorCode, appearance === 'inverse' ? 70 : 10)};
  }
`;
